import { render, staticRenderFns } from "./NormalSearchNav361.vue?vue&type=template&id=5489c9e2&scoped=true"
import script from "./NormalSearchNav361.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav361.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5489c9e2",
  null
  
)

export default component.exports